import { z } from "zod";

/** What a person types to delete an incoming invoice, and the route checks again. */
export const CONFIRM_DELETE_INCOMING_INVOICE = "DELETE THIS INVOICE";

/**
 * Deleting an incoming invoice takes the typed confirmation along, so a stray request — or a
 * client that skipped the dialog — deletes nothing.
 */
export const deleteIncomingInvoiceSchema = z.object({
	confirmation: z.literal(CONFIRM_DELETE_INCOMING_INVOICE),
});

export type DeleteIncomingInvoiceSchema = z.infer<typeof deleteIncomingInvoiceSchema>;
